import DialogLayout from "./DialogLayout";
import { XMarkIcon } from "@heroicons/react/24/outline";
import React from "react";
import { useTranslation } from "react-i18next";

type PropsType = {
  alertIcon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  visible: boolean;
  onClose: () => void;
  showCloseButton?: boolean;
  width?: string | number;
};

const InfoDialog = (props: PropsType) => {
  const { t } = useTranslation();

  const {
    alertIcon,
    title,
    description,
    visible,
    onClose,
    showCloseButton = false,
    width = 400,
  } = props;

  return (
    <DialogLayout show={visible}>
      <div style={{ width: width }}>
        <div className="flex relative h-12 items-center">
          <div className={"pl-2"}></div>
          <div className={"absolute right-2"}>
            <XMarkIcon onClick={onClose} className={"w-5 cursor-pointer hover:text-blue-600"} />
          </div>
        </div>
        {alertIcon && <div className="flex justify-center pb-3">{alertIcon}</div>}
        <div className="text-center px-4 pb-3 text-xl font-bold">{title}</div>
        {description ? (
          <div className="text-center px-4 pb-3 text-base text-gray-500">{description}</div>
        ) : null}
        {showCloseButton ? (
          <div className="w-full">
            <div className={"flex space-x-2 justify-center w-full p-3"}>
              <button
                onClick={onClose}
                type="button"
                className="rounded-sm px-4 py-2 text-xs font-semibold shadow-xs border-1 border-gray-300 border-solid hover:bg-blue-500 hover:text-white focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              >
                {t("Close")}
              </button>
            </div>
          </div>
        ) : (
          <div className="p-3"></div>
        )}
      </div>
    </DialogLayout>
  );
};

export default InfoDialog;
